import { ApplicationFrame } from "@nulogy/components";
import ConfirmModal from "components/common/ConfirmModal";
import React from "react";
import ApplicationNavBar from "./navbar/ApplicationNavBar";

function ApplicationLayoutView({ children, applicationContext: { trainingMode } }) {
  return (
    <ApplicationFrame className="appContainer" navBar={<ApplicationNavBar environment={trainingMode && "TRAINING"} />}>
      {children}
      <ConfirmModal />
    </ApplicationFrame>
  );
}

export default ApplicationLayoutView;
